import "../../index37.css";
import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { _ as c } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
const _ = "_legend-element_1a9ic_1", d = "_color_1a9ic_7", g = "_icon-container_1a9ic_14", N = "_icon_1a9ic_14", b = "_label_1a9ic_31", o = {
  legendElement: _,
  color: d,
  iconContainer: g,
  icon: N,
  label: b
};
function v(a) {
  const {
    className: s,
    colorClassName: i,
    iconClassName: r,
    color: l,
    label: t,
    iconSrc: n
  } = a;
  return /* @__PURE__ */ m("div", { className: c(o.legendElement, s), children: [
    n ? /* @__PURE__ */ e(
      "div",
      {
        style: {
          backgroundColor: l
        },
        className: o.iconContainer,
        children: /* @__PURE__ */ e(
          "img",
          {
            className: c(o.icon, r),
            src: n,
            alt: ""
          }
        )
      }
    ) : /* @__PURE__ */ e(
      "div",
      {
        style: { backgroundColor: l },
        className: c(o.color, i)
      }
    ),
    /* @__PURE__ */ e("div", { className: o.label, children: t })
  ] });
}
export {
  v as default
};
